
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/select",
      function () {
        return require("private-next-pages/gifts/select.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/select"])
      });
    }
  